export const BLOB_STORAGE_URI = 'https://hyper.blob.core.windows.net/biwin/';
export const BLOB_STORAGE_URL_OLD = 'https://hyper.blob.core.windows.net/biwin/';